import { makeStyles } from '@material-ui/core';
import { Color } from 'utils/color';

export const makeCustomSelectStyles = makeStyles(() => ({
  menuPaper: {
    maxHeight: 200
  },
  menuPaperLong: {
    maxHeight: 280
  },
  select: {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${Color.GRAY_300}`,
      boxShadow: '0 0 0 4px rgba(16, 24, 40, 0.05)'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
      borderColor: Color.GRAY_200
    },
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      padding: '10px 14px'
    },
    '&': {
      margin: 'auto 0'
    }
  }
}));

export const makeCustomInputStyles = makeStyles(() => ({
  input: {
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${Color.GRAY_300}`,
      boxShadow: '0 0 0 4px rgba(16, 24, 40, 0.05)'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
      borderColor: Color.GRAY_200
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
      lineHeight: '24px'
    }
  }
}));

export const customInputPlaceholderStyles = {
  'input::placeholder': {
    color: Color.GRAY_700,
    opacity: 1
  }
};

export const customErrorBorderStyles = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: Color.RED_500
  }
};

export const customDateTimePickerStyles = {
  '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${Color.GRAY_300}`,
    boxShadow: '0 0 0 4px rgba(16, 24, 40, 0.05)'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px',
    borderColor: Color.GRAY_200
  },
  '& .Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: `${Color.RED_500} !important`
  },
  input: { padding: '10px 14px', lineHeight: '24px' }
};
